import { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControl
} from '@mui/material';
import { CopyToClipboard } from '../universal/JSONHelper';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import { IsJsonString } from '../universal/JSONHelper';
import { DensityNetworkConfigTable } from '../densityNetworkConfigs/DensityNetworkConfigTable'
import { SelectRowFromTable } from '../universal/Axios';
const store = getStore();


const ExtractDNCParamPath = () => {
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [parentFileContent, setParentFileContent] = useState("");
    const [dncFileContent, setDNCFileContent] = useState("");
    const [paramParentPath, setParamParentPath] = useState("");
    const [errorMessages, setErrorMessages] = useState({});
    const [paramName, setParamName] = useState("");
    const [instance, setInstance] = useState(1);
    const [densityNetworkConfigID, setDensityNetworkConfigID] = useState("");
    const [densityNetworkConfigObject, setDensityNetworkConfigObject] = useState(null);
    const [densityNetworkConfigJSON, setDensityNetworkConfigJSON] = useState(null);

    useEffect(() => {
        if (densityNetworkConfigObject != null && densityNetworkConfigObject["id"] !== undefined) {
            apiClient.post(
                "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
                {
                    "function_to_execute": "Download_File_From_Cloud_Storage",
                    "bucket_name": densityNetworkConfigObject["bucket"],
                    "file_name": densityNetworkConfigObject["bucket_folder"] + "/" + densityNetworkConfigObject["id"] + ".json",
                    "download_type": "text"
                }
            ).then(({ data }) => {
                //setDensityNetworkConfigJSON(JSON.parse(data["file"], null, 2))
                setDensityNetworkConfigJSON(data["file"])
            })
        }
    }, [densityNetworkConfigObject])

    useEffect(() => {
        if (densityNetworkConfigID.length == 1) {

            SelectRowFromTable("select * from density_network_config where id = '" + densityNetworkConfigID[0] + "';", setDensityNetworkConfigObject)
        }
    }, [densityNetworkConfigID])

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const extractParamFromJSON = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Extract_Param_From_JSON",
                "param_name": paramName,
                "instance": instance,
                "density_network_config_id": densityNetworkConfigID[0],
            }
        ).then(({ data }) => {
            console.log(data)
            setParamParentPath(JSON.stringify(data, null, 2))
            store.updateSuccessMessage("Successfully extracted DNC Param Parent Path!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                //const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Density Network Config")
                console.log("error:")
                console.log(error)
                store.updateErrorMessage("Error while extracting JSON path")
            }
        })
    }


    const checkSubmitButtonDisabled = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        console.log(errorMessages)
        setSubmitButtonDisabled(has_errors)
    }

    return (
        <Box>
            <Typography sx={{ marginBottom: '20px' }} variant="h6">Merge Density Network Configs</Typography>
            <Box sx={{ m: 2 }}>
                <FormControl fullWidth size="medium">
                    <Box sx={{height: '500px'} }>
                        <Box style={{ width: '45%', height: '500px', marginBottom: '100px', float: 'left' }}>
                            <h3>
                                Density Network Configs
                            </h3>
                            <DensityNetworkConfigTable parent_id="all" selectDensityNetworkConfig={setDensityNetworkConfigID} selectedDensityNetworkConfig={densityNetworkConfigID} />
                        </Box>
                        <Box style={{ width: '48%', height: '500px', float: 'right', marginBottom: '100px' }}>
                            <TextField
                                label="File Content"
                                variant="outlined"
                                multiline
                                rows={20}
                                value={densityNetworkConfigJSON}
                                maxRows={5000}
                                helperText={errorMessages.id}
                                sx={{width: '100%'} }
                            />
                        </Box>
                    </Box>
                    {/*{errorMessages["applied_has_file_content"] !== undefined && <Typography color="red">{errorMessages["applied_has_file_content"]}</Typography>}*/}
                    {/*{errorMessages["applied_is_valid_json"] !== undefined && <Typography color="red">{errorMessages["applied_is_valid_json"]}</Typography>}*/}
                </FormControl>
            </Box>
            <Box style={{ width: '50%', float: 'right', height: '50px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                <TextField
                    label="Instance Number"
                    variant="outlined"
                    value={instance}
                    onChange={(event) => setInstance(event.target.value)}
                />
                <TextField
                    label="Selected Hyperparameter"
                    variant="outlined"
                    multiline
                    sx={{width: '600px'} }
                    value={paramName}
                    onChange={(event) => setParamName(event.target.value)}
                />
            </Box>
                <Box sx={{ m: 2, clear: 'both' }}>
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button
                            variant="contained"
                            onClick={() => extractParamFromJSON()}
                            disabled={isSubmitButtonDisabled}
                        >
                            Submit
                        </Button>
                    </Stack>
                </Box>
            <Box sx={{ m: 2 }}>
                <FormControl fullWidth>
                    <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', marginBottom: '20px', fontSize: '20px' }}>
                        <Box sx={{ width: '33%', float: "left" }}></Box>
                        <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                            <span sx={{ float: "right" }}><b>Output:</b></span>
                        </Box>
                        <Box sx={{ width: '33%' }}>
                            <Button
                                onClick={() => CopyToClipboard(paramParentPath)}
                                variant="contained"
                                sx={{ float: "right" }}
                            >
                                Copy to Clipboard
                            </Button>
                        </Box>
                    </Box>
                    
                    <TextField
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={paramParentPath}
                        maxRows={5000}
                        onChange={(event) => setParentFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
        </Box>
    )
}

export default ExtractDNCParamPath;